import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Landmark, Users, Drama, Building2, MapPin, Briefcase, BarChart3, GraduationCap, HeartPulse } from "lucide-react";
import { T } from "@/context/LanguageContext";

const ITEMS = [
  { icon: Landmark, label: "History", sub: "Our Past, Our Legacy", to: "/vertical/history" },
  { icon: Users, label: "People", sub: "The Heart of America", to: "/vertical/people" },
  { icon: Drama, label: "Culture", sub: "Diversity & Tradition", to: "/vertical/culture" },
  { icon: Building2, label: "Government", sub: "Laws & Leadership", to: "/vertical/government" },
  { icon: MapPin, label: "Places", sub: "Explore & Discover", to: "/explore/states" },
  { icon: Briefcase, label: "Tourism", sub: "Visit & Experience", to: "/vertical/tourism" },
  { icon: BarChart3, label: "Economy", sub: "Growth & Opportunity", to: "/vertical/economy" },
  { icon: GraduationCap, label: "Education", sub: "Learn & Succeed", to: "/vertical/education" },
  { icon: HeartPulse, label: "Healthcare", sub: "Health & Wellness", to: "/vertical/healthcare" },
];

export function VerticalStrip() {
  return (
    <section className="relative z-20 mx-auto -mt-16 max-w-[1500px] px-4">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="grid grid-cols-3 gap-px overflow-hidden rounded-xl bg-border shadow-2xl md:grid-cols-5 lg:grid-cols-9"
      >
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05, duration: 0.4 }}
          >
            <Link
              to={it.to}
              className="group flex h-full flex-col items-center gap-2 bg-white px-2 py-5 text-center transition-colors hover:bg-parchment"
              data-testid={`vertical-${it.label.toLowerCase()}`}
            >
              <span className="text-oldglory-red transition-transform duration-300 group-hover:-translate-y-1 group-hover:scale-110">
                <it.icon className="h-7 w-7" strokeWidth={1.6} />
              </span>
              <span className="text-[13px] font-bold text-navy"><T>{it.label}</T></span>
              <span className="text-[10px] leading-tight text-muted-foreground"><T>{it.sub}</T></span>
            </Link>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
